module.exports = __webpack_public_path__ + "static/media/autopista.f676e118.svg";